import { SEC_ApiCall, SEC_DataApiPost } from '../func.js';

/** Reject malformed responses rather than displaying an invented access state. */
function validateResponse(response, toolGuid) {
    if (!response || response.message || response.tool?.guid !== toolGuid) {
        throw new Error('Tool access could not be confirmed.');
    }
    return response;
}

/** Load the school's active staff and their module and individual tool grants. */
export async function getToolStaffAccess(toolGuid) {
    const response = validateResponse(await SEC_ApiCall('sysmanager/tools/access/staff', toolGuid === null ? { scope: 'module' } : { toolGuid }), toolGuid);
    if (!Array.isArray(response.items) || response.items.some(item => !item || typeof item.cogId !== 'string' || typeof item.displayName !== 'string' || ![0, 1].includes(item.toolPermissions?.perms) || typeof item.toolPermissions?.toolAllowed !== 'boolean' || typeof item.toolPermissions?.approvedDomainsOnly !== 'boolean')) throw new Error('Invalid staff access list.');
    return response;
}

/** Save an explicitly scoped module or individual tool access change for an active staff account. */
export async function updateToolStaffAccess(toolGuid, targetCogId, value, permission = 'tool') {
    const payload = toolGuid === null
        ? { scope: 'module', targetCogId, permission: 'perms', value }
        : { toolGuid, targetCogId, permission, value };
    const response = validateResponse(await SEC_DataApiPost('sysmanager/tools/access/update', JSON.stringify(payload), {}), toolGuid);
    if (response.targetCogId !== targetCogId || !response.toolPermissions || ![0, 1].includes(response.toolPermissions.perms) || typeof response.toolPermissions.toolAllowed !== 'boolean' || typeof response.toolPermissions.approvedDomainsOnly !== 'boolean') {
        throw new Error('Saved tool access could not be confirmed.');
    }
    return response;
}
